// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation/Navigation.tsx';
import StarsBackground from './components/StarsBackground/StarsBackground.tsx';
import Footer from './components/Footer/Footer.tsx';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton.tsx';
import Home from './pages/Home.tsx';
import Services from './pages/Services.tsx';
import About from './pages/About.tsx';
import Contact from './pages/Contact.tsx';
import SubmitDetails from './pages/SubmitDetails.tsx';
import PaymentSuccess from './pages/PaymentSuccess.tsx';
import KundaliReading from './pages/blog/KundaliReading.tsx';
import VedicVsWestern from './pages/blog/VedicVsWestern.tsx';
import VaastuShastra from './pages/blog/VaastuShastra.tsx';
import './App.css';
//import ChatWidget from './components/ChatWidget/ChatWidget.tsx'; // Import the ChatWidget

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="App">
        <StarsBackground />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/submit-details" element={<SubmitDetails />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/blog/what-is-a-kundali-reading" element={<KundaliReading />} />
            <Route path="/blog/vedic-astrology-vs-western-astrology" element={<VedicVsWestern />} />
            <Route path="/blog/what-is-vaastu-shastra" element={<VaastuShastra />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        {/* <ChatWidget /> */}
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;